import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import {IshState} from 'src/js/services/IshState';
import {ResultComp} from './components/ResultComp';
import {tryAnotherCard} from './actions/Actions';
import { changePhase, resetCheckoutState, sendInitRequest } from '../../actions/Actions';
import {resetPaymentState} from '../payment/actions/Actions';
import {Phase} from '../../reducers/State';
import {IshAction} from 'src/js/actions/IshAction';

const PropsBy = (state: IshState): any => {
  return {
    response: state.checkout.payment.value,
    resetOnInit: state.checkout.payment.resetOnInit,
    result: state.checkout.payment.result,
  };
};

export const ActionsBy = (dispatch: Dispatch<IshAction<any>>): any => {
  return {
    onCancel: () => {
      dispatch(resetCheckoutState());
      dispatch(resetPaymentState());
      // default redirect to courses page
      document.location.href = '/courses';
    },
    onInit: () => {
      dispatch(resetPaymentState());
      dispatch(changePhase(Phase.Init));
      dispatch(sendInitRequest());
    },
    onAnotherCard: () => dispatch(tryAnotherCard()),
  };
};

export const Result = connect<any,any,any>(PropsBy, ActionsBy)(ResultComp);

